import { LoginForm } from '../ui/LoginForm';

export const LoginPage = () => {
  return (
    <div className="login-page">
      <LoginForm />
    </div>
  );
};

export default LoginPage;


